import { createSelector } from "reselect";
import { State } from "../../../redux/state";

export const socialChatRoot = (state: State) => state.socialChat;

export const instagramConversationsSelector = createSelector(socialChatRoot, (me) => 
    me.instagram.conversations.ids.map((id) => me.instagram.conversations.entities[id])
);
export const instagramSelectedSelector = createSelector(socialChatRoot, (me) => me.instagram.selected);
export const instagramMessagesSelector = createSelector(socialChatRoot, (me) =>
    me.instagram.messages.ids.map((id) => me.instagram.messages.entities[id])
);

export const facebookConversationsSelector = createSelector(socialChatRoot, (me) => 
    me.facebook.conversations.ids.map((id) => me.facebook.conversations.entities[id])
);
export const facebookSelectedSelector = createSelector(socialChatRoot, (me) => me.facebook.selected);
export const facebookMessagesSelector = createSelector(socialChatRoot, (me) =>
    me.facebook.messages.ids.map((id) => me.facebook.messages.entities[id])
);

export const whatsappConversationsSelector = createSelector(socialChatRoot, (me) => 
    me.whatsapp.conversations.ids.map((id) => me.whatsapp.conversations.entities[id])
);
export const whatsappSelectedSelector = createSelector(socialChatRoot, (me) => me.whatsapp.selected);
export const whatsappMessagesSelector = createSelector(socialChatRoot, (me) =>
    me.whatsapp.messages.ids.map((id) => me.whatsapp.messages.entities[id])
);
